import React from "react";
import { Badge, Spin } from "antd";

export const parseMicrositePendingCount = (value) => {
  if (value == null || value === "") return 0;
  const n = Number(value);
  return Number.isNaN(n) ? 0 : n;
};

/** Badge estimate from org list + loaded accordion microsite totals. */
export const computeMicrositePendingEstimate = (organisations, totalsByOrg) => {
  if (!organisations?.length) return 0;
  return organisations.reduce((sum, org) => {
    const loadedTotal = totalsByOrg?.[org.id];
    if (loadedTotal != null) {
      return sum + loadedTotal;
    }
    return sum + (org.pendingMicrositeCount ?? 0);
  }, 0);
};

export const PendingTabLabel = ({ label, count }) => {
  const displayCount = parseMicrositePendingCount(count);

  return (
    <span className="pending-tab-badge">
      <span className="pending-tab-badge-text">{label}</span>
      <span
        className="pending-tab-badge-count"
        aria-label={`${displayCount} pending`}
      >
        {displayCount}
      </span>
    </span>
  );
};

export const PendingApprovalsTabLabel = ({ label, count, loading = false }) => {
  const displayCount = parseMicrositePendingCount(count);

  if (loading) {
    return (
      <span className="pending-tab-badge pending-tab-badge--loading">
        <span className="pending-tab-badge-text">{label}</span>
        <span
          className="pending-tab-badge-spinner"
          aria-busy="true"
          aria-label="Loading pending count"
        >
          <Spin size="small" />
        </span>
      </span>
    );
  }

  return (
    <Badge
      className="pending-tab-badge"
      count={displayCount}
      showZero
      overflowCount={20}
    >
      <span className="pending-tab-badge-text">{label}</span>
    </Badge>
  );
};
